var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"havingMoneyShow"},[_c('p',{staticClass:"congratulationsTip"},[_vm._v("恭喜您通过银行初审，获得预授信额度")]),_c('div',{staticClass:"money"},[_c('span',[_vm._v(_vm._s(this.$store.state.commonForms.bwAmount))]),_c('span',[_vm._v("元")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }